import { TPannellumConfig } from '../../types/panellum';

const basePath = 'https://static.treedis.com/projects/holon';

export const pannellumConfigHolon: { [key: number]: TPannellumConfig } = {
  1: {
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/1`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 4,
      cubeResolution: 3176,
    },
    pitch: -10,
    yaw: 0,
    hotSpots: [
      // Building hotspots
      {
        pitch: -20.101224220686404,
        yaw: -0.8367007490317064,
        type: 'info',
        createTooltipArgs: { title: 'A', type: 'building' },
      },
      // POI hotspots
      {
        pitch: -0.1901461730948153,
        yaw: 160.38002349199394,
        type: 'info',
        createTooltipArgs: {
          title: 'מוזיאון העיצוב',
          stem: 50,
          type: 'poi',
          cardDescription: '',
          cardImageSrc: `${basePath}/pano/tags/poi_4.webp`,
          transportation: { car: 8, walk: 30, bicycle: 10 },
        },
      },
      {
        pitch: 0.7851048782449817,
        yaw: -157.990501227729801,
        type: 'info',
        createTooltipArgs: {
          title: 'בת ים',
          stem: 50,
          type: 'poi',
          cardDescription: '',
          cardImageSrc: `${basePath}/pano/tags/poi_5.webp`,
          transportation: { car: 20, bicycle: 20 },
        },
      },
      {
        pitch: 3,
        yaw: 9.074809135094824,
        type: 'info',
        createTooltipArgs: {
          title: 'פארק אריאל שרון',
          stem: 50,
          type: 'poi',
          cardDescription: '',
          cardImageSrc: `${basePath}/pano/tags/poi_3.webp`,
          transportation: { car: 20, bicycle: 45 },
        },
      },
      {
        pitch: 4,
        yaw: -33,
        type: 'info',
        createTooltipArgs: {
          title: 'רמת גן',
          stem: 50,
          type: 'poi',
          cardDescription: '',
          cardImageSrc: `${basePath}/pano/tags/poi_1.webp`,
          transportation: { car: 20, bicycle: 40 },
        },
      },
      {
        pitch: 4.063098070823034,
        yaw: -62,
        type: 'info',
        createTooltipArgs: {
          title: 'תל אביב',
          stem: 50,
          type: 'poi',
          cardDescription: '',
          cardImageSrc: `${basePath}/pano/tags/poi_2.webp`,
          transportation: { car: 25, bicycle: 40 },
        },
      },
      {
        pitch: 5,
        yaw: -2.8798162016554443,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 2',
          stem: 50,
          type: 'scene',
          sceneId: 2,
          imgSrc: `${basePath}/pano/tags/scene_2.webp`,
        },
      },
    ],
  },
  2: {
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/2`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 4,
      cubeResolution: 3176,
    },
    pitch: -10,
    yaw: 0,
    hotSpots: [
      // Building hotspots
      {
        pitch: -12.12911075726058,
        yaw: -5.008624172329064,
        type: 'info',
        createTooltipArgs: { title: 'A', type: 'building' },
      },
      // POI hotspots
      {
        pitch: 4,
        yaw: 137.11658810066223,
        type: 'info',
        createTooltipArgs: {
          title: 'רמת גן',
          stem: 50,
          type: 'poi',
          cardDescription: '',
          cardImageSrc: `${basePath}/pano/tags/poi_1.webp`,
          transportation: { car: 20, bicycle: 40 },
        },
      },
      {
        pitch: 3.5,
        yaw: 172.29062646778243,
        type: 'info',
        createTooltipArgs: {
          title: 'פארק אריאל שרון',
          stem: 50,
          type: 'poi',
          cardDescription: '',
          cardImageSrc: `${basePath}/pano/tags/poi_3.webp`,
          transportation: { car: 20, bicycle: 45 },
        },
      },
      {
        pitch: 1.409058175006543,
        yaw: -24.662210469000115,
        type: 'info',
        createTooltipArgs: {
          title: 'מוזיאון העיצוב',
          stem: 50,
          type: 'poi',
          cardDescription: '',
          cardImageSrc: `${basePath}/pano/tags/poi_4.webp`,
          transportation: { car: 8, walk: 30, bicycle: 10 },
        },
      },
      {
        pitch: 1.5226285920993103,
        yaw: 8.842265513663847,
        type: 'info',
        createTooltipArgs: {
          title: 'בת ים',
          stem: 50,
          type: 'poi',
          cardDescription: '',
          cardImageSrc: `${basePath}/pano/tags/poi_5.webp`,
          transportation: { car: 20, bicycle: 20 },
        },
      },
      {
        pitch: 4,
        yaw: 106.40917142549506,
        type: 'info',
        createTooltipArgs: {
          title: 'תל אביב',
          stem: 50,
          type: 'poi',
          cardDescription: '',
          cardImageSrc: `${basePath}/pano/tags/poi_2.webp`,
          transportation: { car: 25, bicycle: 40 },
        },
      },
      {
        pitch: 5,
        yaw: -5.2554839915191,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 1',
          stem: 50,
          type: 'scene',
          sceneId: 1,
          imgSrc: `${basePath}/pano/tags/scene_1.webp`,
        },
      },
    ],
  },
};
